import { Site } from '@nucleus/types/web';
import { createContext } from 'react';

export interface SiteContextValue {
  getSite(): Site;
}
export const SiteContext = createContext<SiteContextValue>({} as SiteContextValue);
